export default __webpack_public_path__ + "static/game-intro-04-da38cb62fc791f6ebf9d5cae20dea0a8.png";